module.exports = __webpack_public_path__ + "img/onboarding-modal-image-03.8aa9b8c.svg";